import { render, staticRenderFns } from "./keywords.vue?vue&type=template&id=1cce4d84"
import script from "./keywords.ts?vue&type=script&lang=js&external"
export * from "./keywords.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports